import { StyleSheet } from 'react-native';
import colors from '@/config/colors';

export const styles = StyleSheet.create({
  redText: { color: colors.red },
  centeredView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#00000099',
  },
  underline: {
    width: '100%',
    height: 1,
    marginBottom: 10,
    backgroundColor: colors.grey,
  },
  modalView: {
    backgroundColor: 'white',
    padding: 10,
    alignItems: 'center',
    maxWidth: 500,
    marginHorizontal: 10,
  },
  modalButton: {
    color: colors.white,
    fontWeight: '700',
    textAlign: 'center',
  },
  modalTitle: {
    marginBottom: 10,
    textAlign: 'center',
    opacity: 0.5,
    fontWeight: '700',
  },
  modalText: {
    marginBottom: 15,
    fontSize: 22,
  },
  button: {
    width: '100%',
    padding: 10,
    backgroundColor: colors.darkPurpleBlue,
    borderColor: 'transparent',
  },
  body: {
    flex: 1,
    paddingHorizontal: 4,
    paddingTop: 4,
  },
  avatarListWrapper: {
    marginTop: 20,
  },
  formContent: {
    width: '90%',
    marginRight: 'auto',
    marginLeft: 'auto',
  },
  formFieldTwoThirds: {
    alignSelf: 'flex-start',
    width: '66%',
    padding: 20,
  },
  formFieldOneThird: {
    alignSelf: 'flex-start',
    width: '33%',
    paddingBottom: 20,
    paddingHorizontal: 20,
  },
});
